import { render, staticRenderFns } from "./PicType-rejectList.vue?vue&type=template&id=a19e2ce6&scoped=true&"
import script from "./PicType-rejectList.vue?vue&type=script&lang=js&"
export * from "./PicType-rejectList.vue?vue&type=script&lang=js&"
import style0 from "./PicType-rejectList.vue?vue&type=style&index=0&id=a19e2ce6&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a19e2ce6",
  null
  
)

export default component.exports